var cookie = {};
export {
  cookie as __exports
};
//# sourceMappingURL=cookie.js.map
